var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.25em",
    height: "1.25em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "#1977F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.672 15.47l.531-3.47h-3.327V9.749c0-.949.464-1.875 1.955-1.875h1.514V4.921s-1.374-.235-2.686-.235c-2.741 0-4.533 1.66-4.533 4.67V12H7.078v3.47h3.048v8.385a12.258 12.258 0 003.75 0V15.47h2.796z",
    fill: "#fff"
  })));
}
export default SvgFacebook;